import { getHeaders } from "../utils/serviceHelper";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getUserExamResponses = async (userId) => {
  const res = await fetch(`${BASE_URL}/exam-response/user/${userId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    headers: getHeaders(),
  });
  return await res.json();
};
